class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');

    this.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button.name) return;
      this.handleStep(button.name);
    });

    this.input.addEventListener('change', () => {
      this.constrainAndUpdateInput(this.input.value);
      this.publishQuantityChange();
    });
  }

  /**
   * Handle the step up or step down of the quantity
   * @param {string} type - The type of step to be taken
   */
  handleStep(type) {
    const value = parseInt(this.input.value);
    const step = parseInt(this.input.step) || 1;
    const newValue = type === 'minus' ? Math.max(value - step, 0) : value + step;
    const updatedValue = this.constrainAndUpdateInput(newValue);

    if (parseInt(updatedValue) === parseInt(value)) return;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * Constrain and update the input.
   * @param {number} newValue - The new value.
   * @returns {number} The constrained value.
   */
  constrainAndUpdateInput(newValue) {
    const min = parseInt(this.input.min) || 0;
    const max = this.input.max ? parseInt(this.input.max) : null;

    this.input.value = newValue;

    if (max !== null && newValue >= max) {
      window.toast.error(
        window.toast_translations.product.quantity_error_max.replace('{{ max }}', max)
      );
      this.input.value = max;
    } else if (newValue <= min) {
      this.input.value = min;
    }
    return this.input.value;
  }

  publishQuantityChange() {
    const lineItem = this.closest('line-item');

    publish('quantity:change', {
      line: this.dataset?.itemIndex,
      productId: lineItem?.dataset?.lineItemId,
      quantity: this.input.value,
    });
  }
}

customElements.define('quantity-input', QuantityInput);
